import { render } from "./magic-remote-joystick.vue?vue&type=template&id=b3a74b60&scoped=true&ts=true"
import script from "./magic-remote-joystick.vue?vue&type=script&lang=ts"
export * from "./magic-remote-joystick.vue?vue&type=script&lang=ts"

import "./magic-remote-joystick.vue?vue&type=style&index=0&id=b3a74b60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3a74b60"]])

export default __exports__